var _path, _path2, _path3, _g, _g2, _g3, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnOnOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 103,
    viewBox: "0 0 132 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.995 31.5002L43.2631 23.322L28.5465 14.1885L27.995 31.5002ZM36.2231 21.0397C37.6426 19.479 39.519 17.8266 42.3577 15.7375L40.5795 13.3213C37.647 15.4794 35.6025 17.2633 34.0037 19.0211L36.2231 21.0397ZM42.3577 15.7375C50.5842 9.68348 60.4212 6.20496 70.6247 5.74188L70.4887 2.74496C59.6924 3.23495 49.2839 6.91555 40.5795 13.3213L42.3577 15.7375ZM70.6247 5.74188C80.8283 5.2788 90.9399 7.85196 99.6809 13.1359L101.233 10.5686C91.9841 4.97763 81.285 2.25498 70.4887 2.74496L70.6247 5.74188Z",
    fill: "#666666",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55078 39.4153C7.58138 39.4153 8.45095 39.5313 9.1595 39.7632C9.86804 39.9822 10.4349 40.3558 10.86 40.884C11.2851 41.4121 11.5943 42.1207 11.7875 43.0096C11.9937 43.8985 12.0967 45.0064 12.0967 46.3333C12.0967 47.6473 11.9937 48.7552 11.7875 49.657C11.5943 50.5459 11.2851 51.2544 10.86 51.7826C10.4349 52.3108 9.86804 52.6908 9.1595 52.9227C8.45095 53.1417 7.58138 53.2512 6.55078 53.2512C5.54594 53.2512 4.68925 53.1417 3.98071 52.9227C3.27217 52.6908 2.69889 52.3108 2.26089 51.7826C1.82288 51.2544 1.50726 50.5459 1.31402 49.657C1.12078 48.7552 1.02416 47.6473 1.02416 46.3333C1.02416 45.0064 1.12078 43.8985 1.31402 43.0096C1.50726 42.1207 1.82288 41.4121 2.26089 40.884C2.69889 40.3558 3.27217 39.9822 3.98071 39.7632C4.68925 39.5313 5.54594 39.4153 6.55078 39.4153ZM6.55078 41.3864C5.79071 41.3864 5.19167 41.541 4.75366 41.8502C4.32854 42.1464 4.0258 42.6553 3.84544 43.3767C3.66509 44.0853 3.57491 45.0708 3.57491 46.3333C3.57491 47.5958 3.66509 48.5877 3.84544 49.3091C4.0258 50.0177 4.32854 50.5265 4.75366 50.8357C5.19167 51.132 5.79071 51.2802 6.55078 51.2802C7.32373 51.2802 7.92277 51.132 8.34789 50.8357C8.7859 50.5265 9.09508 50.0177 9.27544 49.3091C9.45579 48.5877 9.54597 47.5958 9.54597 46.3333C9.54597 45.0708 9.45579 44.0853 9.27544 43.3767C9.09508 42.6553 8.7859 42.1464 8.34789 41.8502C7.92277 41.541 7.32373 41.3864 6.55078 41.3864ZM17.3086 39.6279C17.9656 39.6279 18.629 39.6344 19.2989 39.6472C19.9817 39.6472 20.6516 39.6601 21.3086 39.6859C21.9785 39.6988 22.5969 39.7374 23.1637 39.8018L23.0477 41.5796H18.1395C17.753 41.5796 17.4632 41.6698 17.2699 41.8502C17.0767 42.0305 16.9801 42.3139 16.9801 42.7004V53H14.5646V42.2173C14.5646 41.4057 14.8158 40.7745 15.3182 40.3236C15.8206 39.8598 16.4841 39.6279 17.3086 39.6279ZM14.8931 45.3478H22.3134V47.1256H14.8931V45.3478ZM27.914 39.6279C28.571 39.6279 29.2345 39.6344 29.9044 39.6472C30.5872 39.6472 31.257 39.6601 31.9141 39.6859C32.5839 39.6988 33.2023 39.7374 33.7691 39.8018L33.6532 41.5796H28.7449C28.3585 41.5796 28.0686 41.6698 27.8754 41.8502C27.6821 42.0305 27.5855 42.3139 27.5855 42.7004V53H25.17V42.2173C25.17 41.4057 25.4212 40.7745 25.9237 40.3236C26.4261 39.8598 27.0895 39.6279 27.914 39.6279ZM25.4985 45.3478H32.9189V47.1256H25.4985V45.3478Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.551 17.4153C112.581 17.4153 113.451 17.5313 114.159 17.7632C114.868 17.9822 115.435 18.3558 115.86 18.884C116.285 19.4121 116.594 20.1207 116.788 21.0096C116.994 21.8985 117.097 23.0064 117.097 24.3333C117.097 25.6473 116.994 26.7552 116.788 27.657C116.594 28.5459 116.285 29.2544 115.86 29.7826C115.435 30.3108 114.868 30.6908 114.159 30.9227C113.451 31.1417 112.581 31.2512 111.551 31.2512C110.546 31.2512 109.689 31.1417 108.981 30.9227C108.272 30.6908 107.699 30.3108 107.261 29.7826C106.823 29.2544 106.507 28.5459 106.314 27.657C106.121 26.7552 106.024 25.6473 106.024 24.3333C106.024 23.0064 106.121 21.8985 106.314 21.0096C106.507 20.1207 106.823 19.4121 107.261 18.884C107.699 18.3558 108.272 17.9822 108.981 17.7632C109.689 17.5313 110.546 17.4153 111.551 17.4153ZM111.551 19.3864C110.791 19.3864 110.192 19.541 109.754 19.8502C109.329 20.1464 109.026 20.6553 108.845 21.3767C108.665 22.0853 108.575 23.0708 108.575 24.3333C108.575 25.5958 108.665 26.5877 108.845 27.3091C109.026 28.0177 109.329 28.5265 109.754 28.8357C110.192 29.132 110.791 29.2802 111.551 29.2802C112.324 29.2802 112.923 29.132 113.348 28.8357C113.786 28.5265 114.095 28.0177 114.275 27.3091C114.456 26.5877 114.546 25.5958 114.546 24.3333C114.546 23.0708 114.456 22.0853 114.275 21.3767C114.095 20.6553 113.786 20.1464 113.348 19.8502C112.923 19.541 112.324 19.3864 111.551 19.3864ZM130.444 17.6666V30.0918C130.444 30.6973 130.148 31 129.555 31H127.912C127.642 31 127.436 30.942 127.294 30.8261C127.152 30.6973 127.024 30.5105 126.908 30.2657L122.869 22.227C122.727 21.9436 122.579 21.6344 122.425 21.2994C122.283 20.9516 122.167 20.6231 122.077 20.3139H121.825C121.851 20.636 121.871 20.9645 121.883 21.2994C121.909 21.6215 121.922 21.9436 121.922 22.2656V31H119.603V18.5748C119.603 17.9693 119.9 17.6666 120.492 17.6666H122.096C122.367 17.6666 122.573 17.731 122.714 17.8598C122.856 17.9757 122.985 18.1561 123.101 18.4009L127.024 26.227C127.178 26.5104 127.333 26.8325 127.487 27.1932C127.655 27.541 127.809 27.8953 127.951 28.256H128.241C128.215 27.8824 128.189 27.5217 128.164 27.1739C128.151 26.8132 128.144 26.4589 128.144 26.1111V17.6666H130.444Z",
    fill: "#999999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_11195_79112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 60,
    r: 36,
    fill: "url(#paint0_linear_11195_79112)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_11195_79112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.9975,
    cy: 59.9975,
    r: 22.56,
    fill: "#222222"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_11195_79112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.8456,
    cy: 15.8456,
    r: 15.8456,
    transform: "matrix(-0.798379 -0.602155 -0.602155 0.798379 99.1953 56.8984)",
    fill: "#555555"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.5564,
    y: 49.2613,
    width: 5.65915,
    height: 22.6366,
    transform: "rotate(37.0244 81.5564 49.2613)",
    fill: "#222222",
    stroke: "#AAAAAA",
    strokeWidth: 1.13183
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_11195_79112",
    x: 36.68,
    y: 19.68,
    width: 82.56,
    height: 82.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_11195_79112"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11195_79112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11195_79112",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.4,
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11195_79112"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.4,
    dy: -2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_11195_79112",
    result: "effect3_innerShadow_11195_79112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_11195_79112",
    x: 54.4375,
    y: 35.5175,
    width: 45.1172,
    height: 49.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.31385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11195_79112"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11195_79112",
    result: "effect2_innerShadow_11195_79112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_11195_79112",
    x: 60.5903,
    y: 43.5981,
    width: 32.8271,
    height: 32.8193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.565915,
    dy: 0.565915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.26366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11195_79112"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.565915,
    dy: -0.565915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.13183
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11195_79112",
    result: "effect2_innerShadow_11195_79112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11195_79112",
    x1: 113,
    y1: 60,
    x2: 41,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757577"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnOnOff);
export default __webpack_public_path__ + "static/media/ign-on-off.015eff5d46096231222366c69e8fd021.svg";
export { ForwardRef as ReactComponent };